import { createRouter, createWebHistory } from 'vue-router'
import { useSession } from './stores/session'
import LoginPage from './pages/LoginPage.vue'
import RegisterPage from './pages/RegisterPage.vue'
import InvitationPage from './pages/InvitationPage.vue'
import HomePage from './pages/HomePage.vue'
import WorkspacesPage from './pages/WorkspacesPage.vue'
import MembersPage from './pages/MembersPage.vue'
import CompanyPage from './pages/CompanyPage.vue'
import SettingsPage from './pages/SettingsPage.vue'
import AccountsPage from './pages/AccountsPage.vue'
import TransactionsPage from './pages/TransactionsPage.vue'
import ImportPage from './pages/ImportPage.vue'
import RulesPage from './pages/RulesPage.vue'
import BillsPage from './pages/BillsPage.vue'
import DocumentsPage from './pages/DocumentsPage.vue'
import UtilitiesPage from './pages/UtilitiesPage.vue'
import ReconciliationPage from './pages/ReconciliationPage.vue'
import BudgetPage from './pages/BudgetPage.vue'
import SavingsPage from './pages/SavingsPage.vue'
import ObligationsPage from './pages/ObligationsPage.vue'

declare module 'vue-router' {
  interface RouteMeta {
    /** reachable without a session (layout: auth) */
    public?: boolean
    /** only for signed-out users (login/register) */
    guest?: boolean
    /** only in business workspaces */
    business?: boolean
  }
}

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', component: LoginPage, meta: { public: true, guest: true } },
    { path: '/register', component: RegisterPage, meta: { public: true, guest: true } },
    { path: '/invite/:token', component: InvitationPage, meta: { public: true } },
    { path: '/', component: HomePage },
    { path: '/accounts', component: AccountsPage },
    { path: '/transactions', component: TransactionsPage },
    { path: '/import', component: ImportPage },
    { path: '/rules', component: RulesPage },
    { path: '/bills', component: BillsPage },
    { path: '/documents', component: DocumentsPage },
    { path: '/utilities', component: UtilitiesPage },
    { path: '/reconciliation', component: ReconciliationPage },
    { path: '/budget', component: BudgetPage },
    { path: '/savings', component: SavingsPage },
    { path: '/obligations', component: ObligationsPage },
    { path: '/workspaces', component: WorkspacesPage },
    { path: '/members', component: MembersPage },
    { path: '/company', component: CompanyPage, meta: { business: true } },
    { path: '/settings', component: SettingsPage },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  const s = useSession()
  if (!s.ready) await s.boot()
  if (to.meta.guest && s.authenticated) return typeof to.query.redirect === 'string' ? to.query.redirect : '/'
  if (!to.meta.public && !s.authenticated) return { path: '/login', query: { redirect: to.fullPath } }
  if (to.meta.business && !s.isBusiness) return '/'
})
